import { render, staticRenderFns } from "./TaxInvoiceRed.vue?vue&type=template&id=47a965f8&scoped=true&"
import script from "./TaxInvoiceRed.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceRed.vue?vue&type=script&lang=js&"
import style0 from "./TaxInvoiceRed.vue?vue&type=style&index=0&id=47a965f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a965f8",
  null
  
)

export default component.exports